import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaPropertyExamples.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                           */
//#region src/schema/SchemaPropertyExamples.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-1380dfca"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaPropertyExamples.vue.js.map